// extracted by mini-css-extract-plugin
module.exports = {"root":"Status_root__1C4Et","approved":"Status_approved__30eXb","rejected":"Status_rejected__1r4Qu","expired":"Status_expired__29o5u","label":"Status_label__B0Dlv"};